import Schema from 'validate';
import isEmail from 'validator/lib/isEmail';
import { isPostalCode } from 'validator';

import OrgaSchema from '../../../../lib/paths/unternehmen_FULL_Paths.json'
const P = OrgaSchema.attributes;

const mailValidator = (val: string) => isEmail(val);
const postalCodeValidator = (val: string) => isPostalCode(val, 'DE');

const OrganisationDatenValidator = new Schema({
	// [P.Unternehmensprofil_U_St_Id_Nr.path]: {
	// 	type: String,
	// 	required: true,
	// },
	[P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path]: {
		type: String,
		required: true,
	},
	// [P.Geschaeftsbezogene_Daten_Rechtsform_Der_Organisation.path]: {
	// 	type: String,
	// 	required: true,
	// },
	[P.Adressdaten_Strasse_Und_Hausnummer.path]: {
		type: String,
		required: true,
	},
	[P.Adressdaten_PLZ.path]: {
		type: String,
		required: true,
		use: { postalCodeValidator },
		message: {
			postalCodeValidator: 'Ungültige Postleitzahl.',
		},
	},
	[P.Adressdaten_Ort.path]: {
		type: String,
		required: true,
	},
	[P.Geschaeftsbezogene_Daten_Kurzbeschreibung_Der_Organisation.path]: {
		type: String,
	},
	// [P.Geschaeftsbezogene_Daten_Rolle.path]: {
	// 	type: String,
	// 	required: true,
	// },
	[P.Kontaktdaten_E_Mail.path]: {
		type: String,
		required: true,
		use: { mailValidator },
		message: {
			mailValidator: 'Ungültige E-Mail-Adresse.',
		},
	},
	[P.Kontaktdaten_Telefon.path]: {
		type: String,
		required: true,
		use: {
			phone: (val: string) => /^[0-9\s]*$/.test(val),
		},
		message: {
			phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
		},
	},
});

OrganisationDatenValidator.message({
	required: (_path: string) => 'Dies ist ein Pflichfeld',
	type: (path: string) =>
		`Das Formular ist fehlerhaft, bitte melden Sie diesen Felder. Geben Sie als Grund "falscher Datantyp, ${path}" an`,
});

export default OrganisationDatenValidator;
